<mat-form-field>
  <mat-select [formControl]="inputCtrl">
    <mat-option *ngFor="let item of list"
                [value]="item.id">{{item.name}}</mat-option>
  </mat-select>
</mat-form-field>
